//Module Keys
let locales = {};

//Merge Views

//Main
import mainView from '../../views/main/lan/es';
locales = { ...locales, ...mainView };

import performanceDashboardView from '../../views/dashboard/lan/es';
locales = { ...locales, ...performanceDashboardView };

import performanceDriverView from '../../views/driver/lan/es';
locales = { ...locales, ...performanceDriverView };

import performanceEventsView from '../../views/events/lan/es';
locales = { ...locales, ...performanceEventsView };

import performanceEventsAdvancedFilters from '../../views/events/modals/advancedFilters/lan/es';
locales = { ...locales, ...performanceEventsAdvancedFilters };

import performanceEventsDriverInfo from '../../views/events/modals/driverInfo/lan/es';
locales = { ...locales, ...performanceEventsDriverInfo };

import performanceEventsEditEvent from '../../views/events/modals/editEvent/lan/es';
locales = { ...locales, ...performanceEventsEditEvent };

import performanceEventsAssetInfo from '../../views/events/modals/assetInfo/lan/es';
locales = { ...locales, ...performanceEventsAssetInfo };

import performanceEventsEventInfo from '../../views/events/modals/eventInfo/lan/es';
locales = { ...locales, ...performanceEventsEventInfo };

import performanceDriverModals from '../../views/driver/modals/advancedFilters/lan/es';
locales = { ...locales, ...performanceDriverModals };

import overviewTab from '../../views/overviewTab/lan/es';
locales = { ...locales, ...overviewTab };

import caseDetailView from '../../views/caseDetail/lan/es';
locales = { ...locales, ...caseDetailView };

import caseView from '../../views/cases/lan/es';
locales = { ...locales, ...caseView };

import performanceCasesEditCoachPanel from '../../views/cases/modals/editCoachPanel/lan/es';
locales = { ...locales, ...performanceCasesEditCoachPanel };

import performanceDriverDetail from '../../views/driverDetail/lan/es';
locales = { ...locales, ...performanceDriverDetail };

import performanceCasesAdvancedFilters from '../../views/cases/modals/advancedFilters/lan/es';
locales = { ...locales, ...performanceCasesAdvancedFilters };

import performanceCasesCreatePanel from '../../views/cases/modals/createPanel/lan/es';
locales = { ...locales, ...performanceCasesCreatePanel };

import performanceImplovementPlanTab from '../../views/implovementPlanTab/lan/es';
locales = { ...locales, ...performanceImplovementPlanTab };

import performanceOverviewTabDriver from '../../views/overviewTabDriver/lan/es';
locales = { ...locales, ...performanceOverviewTabDriver };

import performanceEventsCaseInfo from '../../views/events/modals/caseInfo/lan/es';
locales = { ...locales, ...performanceEventsCaseInfo };

import performanceEventsRiskTab from '../../views/riskTab/lan/es';
locales = { ...locales, ...performanceEventsRiskTab };

import performanceDriverModalsCreateDriverCoaching from '../../views/driver/modals/createDriverCoaching/lan/es';
locales = { ...locales, ...performanceDriverModalsCreateDriverCoaching };

import performanceCasesViewCreatePanel from '../../views/cases/modals/viewCreationPanel/lan/es';
locales = { ...locales, ...performanceCasesViewCreatePanel };

import performanceEventsAssignDriver from '../../views/events/modals/assingDriver/lan/es';
locales = { ...locales, ...performanceEventsAssignDriver };

import performanceEventsAssignStatus from '../../views/events/modals/assingStatus/lan/es';
locales = { ...locales, ...performanceEventsAssignStatus };

import performanceHistoryTooltip from '../../views/implovementPlanTab/modals/historyTooltip/lan/es';
locales = { ...locales, ...performanceHistoryTooltip };

import performanceFunctionTab from '../../views/functionTab/lan/es';
locales = { ...locales, ...performanceFunctionTab };

import coachingEducationWidget from '../../views/functionTab/widgets/coachingEducation/lan/es';
locales = { ...locales, ...coachingEducationWidget };

import performanceImprovementWidget from '../../views/functionTab/widgets/performanceImprovement/lan/es';
locales = { ...locales, ...performanceImprovementWidget };

import interventionWidget from '../../views/functionTab/widgets/intervention/lan/es';
locales = { ...locales, ...interventionWidget };

import escalationWidget from '../../views/functionTab/widgets/escalation/lan/es';
locales = { ...locales, ...escalationWidget };

import configurationDetail from '../../views/configurationDetail/lan/es';
locales = { ...locales, ...configurationDetail };

import performanceRiskEventsTab from '../../views/riskEventsTab/lan/es';
locales = { ...locales, ...performanceRiskEventsTab };

import dateRangeModal from '../../views/overviewTab/modals/dateRangeModal/lan/es';
locales = { ...locales, ...dateRangeModal };

export default locales;
